<template>
  <el-dialog title="Importação planilha de Fale Conosco" :visible.sync="dialog"  width="50%" :fullscreen="false" :close-on-click-modal="false" v-loading="loading">
    <el-form :model="form">
      <el-form-item :label="label" prop="imei">
        <el-upload class="avatar-uploader" action="upload" :show-file-list="true" :auto-upload="false"
          :on-change="change">
          <img v-if="content" class="fa fa-file-excel-o avatar-uploader-icon" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="send">Enviar</el-button>
      <el-button type="info" @click="close">Cancelar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { ServicesService } from "@/services/customers/services.services";
export default {
  name: "UploadLogo",
  data() {
    return {
      dialog: false,
      loading: false,
      file: "",
      form: {},
    }
  },
  methods: {
    open() {
      const vm = this;
      vm.dialog = true;
      vm.content = "";
    },
    send() {
      this.$emit("uploaded", {
        file: this.file,
      })
      this.dialog = false;
    },
    close() {
      this.dialog = false;
    },
    change(file, fileList) { 
      var vm = this;
      console.log('change', file, fileList)
      vm.file = file;
    },
  }
}
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 208px;
  height: 120px;
  line-height: 116px;
  text-align: center;
}

.image-service {
  width: 208px;
  height: 120px;
  display: block;
}
</style>
